import { useRef } from "react";
import { ActionHandlerProvider } from "../Components/ActionHandlerContext";

import { FormInstance } from "antd";
import InterfaceComponent from "./Masters/InterfaceComponent";
import {
  ValidateDynamicFormFields
} from "../Helpers/APIEndpoints/Endpoints";
import { API } from "../Axios/Axios";

export default function ActionTracker() {
  const formRef = useRef<FormInstance>(null);
  
  const interfaceActionHandler = {
    customJsonMethod: async (apiValues, fieldName) => {
      console.log('customJsonMethod called');
      let value = {
        "testMarks": 32358
      }

      return value;
    },

    ValidateForm: async (button: any, form: any) => {
      const validationResult = await API.post(ValidateDynamicFormFields, {
                    InterfaceId: 31,
                    Mode: "Create",
                    ActionType: button?.actionKey,
                    FieldIds: "",
                    FormData: JSON.stringify(form),
                  });
                  return validationResult;
    },
    handleSaveAndNext: async (button: any, form: any) => {
      let formData: Record<string, any>;
      if ('getFieldsValue' in form) {
        formData = form.getFieldsValue();
      } else {
        formData = form;
      }

      console.log(formData);
      
      await formRef.current!.setPrevTabAsActive();
    },
    SaveSectionWiseDetails: async (SectionName: any, formData: any)=> {
      console.log(SectionName);
      console.log(formData);
    }
  };

  const interfaceFieldActionHandler = {
    hideShowTabsOnFieldChange: async (form: any) => {
      let formData: Record<string, any>;
      if ('getFieldsValue' in form) {
        formData = form.getFieldsValue();
      } else {
        formData = form;
      }
      console.log(formData);
    }
  };

  return (
    
      <ActionHandlerProvider
        
        interfaceActionHandler={interfaceActionHandler}
        interfaceFieldActionHandler={interfaceFieldActionHandler}
      >
       <InterfaceComponent
          InterfaceName={"Actions"}
          DashboardName={""}
          actionType={"DynamicFormActionCreate"}
          RId={null}
          Mode={"Create"}
          //handleCancel={handleCancel}
          ref={formRef}
        />
        
      </ActionHandlerProvider>
    
  );
}
